var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-company-info-wrapper",
    { attrs: { company: _vm.company } },
    [
      _c("app-company-edit-default", {
        attrs: { value: _vm.company, "is-info": "" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }